import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { UiModule } from '../../../components/ui.module';
import { EditModeContextWithOriginalState } from '../../../types';

type CellParams = ICellRendererParams & {
  isEditing: () => boolean;
  isSaving: () => boolean;
  editContext: () => EditModeContextWithOriginalState;
  stripeProductPrices: () => any[];
};

@Component({
  selector: 'app-cell-subscriptions-plan',
  imports: [UiModule, NgSelectModule, FormsModule],
  templateUrl: './cell-subscriptions-plan.component.html',
  styleUrl: './cell-subscriptions-plan.component.scss',
})
export class CellSubscriptionsPlanComponent implements ICellRendererAngularComp {
  public params!: CellParams;

  agInit(params: CellParams) {
    this.params = params;
  }

  refresh(params: CellParams) {
    this.params = params;
    return true;
  }

  getStripeProductPriceById(priceId: string) {
    return (this.params.stripeProductPrices() ?? []).find((p) => p.id === priceId)?.product.name ?? 'No Theft Plan';
  }
}
